module.exports = __webpack_public_path__ + "static/img/products discription_Clear PVC Film2.414f385c.jpg";